export default __webpack_public_path__ + "static/media/CNo.46-2.16b39dc4.jpg";